import { Box, Container, Typography, Paper } from '@mui/material';

const TermsOfService = () => {
	return (
		<Container maxWidth="md" sx={{ py: 4 }}>
			<Paper elevation={1} sx={{ p: 4 }}>
				<Typography variant="h4" gutterBottom>
					Terms of Service
				</Typography>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					WhatsApp Service Usage
				</Typography>
				<Typography paragraph>
					By using our service, you agree to receive communications via WhatsApp:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">Authentication codes and login verification</Typography>
					<Typography component="li">Service notifications and updates</Typography>
					<Typography component="li">Important account-related communications</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					Account Terms
				</Typography>
				<Typography paragraph>
					When using our service, you agree to:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">Provide accurate and complete registration information</Typography>
					<Typography component="li">Maintain the security of your account credentials</Typography>
					<Typography component="li">Accept responsibility for all activities under your account</Typography>
					<Typography component="li">Comply with all applicable laws and regulations</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					Service Usage
				</Typography>
				<Typography paragraph>
					Our service terms include:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">Fair and appropriate use of the platform</Typography>
					<Typography component="li">No unauthorized access or system interference</Typography>
					<Typography component="li">Respect for intellectual property rights</Typography>
					<Typography component="li">Compliance with data protection regulations</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					Modifications
				</Typography>
				<Typography paragraph>
					We reserve the right to modify these terms at any time. Continued use of the service after changes
					constitutes acceptance of the modified terms.
				</Typography>

				<Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
					Last updated: May 5, 2025
				</Typography>
			</Paper>
		</Container>
	);
};

export default TermsOfService;
